import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { map, switchMap, tap } from 'rxjs/operators';
import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import * as AppStoreActions from '../../root-store/app-store/actions';
import { AuthenticationService } from '../services';
import { AppConstants } from '../../app.constants';

@Injectable({
	providedIn: 'root'
})
export class AuthenticationInterceptor implements HttpInterceptor {

	private authenticationService = inject(AuthenticationService)
	private store = inject(Store)

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

		// do not send authentication info for assets and connection request
		if (req.url.includes('/assets')) {
			return next.handle(req);
		}

		if (req.url.includes('connect/token')) {
			return next.handle(this.addTenantToRequest(req, this.authenticationService.getTenantId()));
		}

		return this.authenticationService.getAccessToken().pipe(
			switchMap((token: string) => next.handle(this.addTokenAndTenantToRequest(
				req,
				token,
				this.authenticationService.getTenantId())
			)),
			tap(_ => {
				// Update activity date on each successful api request
				if (!AppConstants.REFRESH_ACTIVITY_EXCLUDED_APIS.some(v => req.url.includes(v))) {
					this.store.dispatch(AppStoreActions.UpdateUserSessionRequest({source: `successful api request (${(new URL(req.url).pathname)})`}));
				}
			}),
		);
	}

	addTokenAndTenantToRequest(req: HttpRequest<any>, token: string, tenant: string): HttpRequest<any> {
		return req.clone({
			setHeaders: this.authHeaders(token, tenant)
		});
	}

	getAuthHeaders(): Observable<Record<string, string>> {
		return this.authenticationService.getAccessToken().pipe(map(token => this.authHeaders(
			token,
			this.authenticationService.getTenantId(),
		)))
	}

	private addTenantToRequest(req: HttpRequest<any>, tenant: string): HttpRequest<any> {
		return req.clone({
			setHeaders: {
				'X-Aston-TenantId': tenant
			}
		});
	}

	private authHeaders(token: string, tenant: string): Record<string, string> {
		return {
			Authorization: `Bearer ${token}`,
			'X-Aston-TenantId': tenant
		}
	}
}
